import { render, staticRenderFns } from "./IntegrationPricingTiers.vue?vue&type=template&id=75f39976&scoped=true"
import script from "./IntegrationPricingTiers.vue?vue&type=script&lang=ts"
export * from "./IntegrationPricingTiers.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationPricingTiers.vue?vue&type=style&index=0&id=75f39976&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f39976",
  null
  
)

export default component.exports